<script setup lang="ts">

import type { AcMilestone } from '@/types/crm';
import { formatUser } from '../../mixins/visualFormatters';
import { useStore } from "vuex";
import { computed } from 'vue';
import { ref } from 'vue';
import acIconPicker from '../reusable/acIconPicker.vue';

const store = useStore()
const user = computed(() => store.getters["user/userProfile"])
const formattedUser = formatUser(user.value)

const emits = defineEmits(["milestoneTypeAdded", "milestoneTypeUpdated", "cancelled"])
const props = defineProps(["existingMilestoneType", "existingMilestoneCategories"])

const isAddingNewCategory = ref(false)

const milestoneType = ref<AcMilestone>({
    id: props.existingMilestoneType?.id ?? "",
    title: props.existingMilestoneType?.title ?? "",
    icon: props.existingMilestoneType?.icon ?? "",
    category: props.existingMilestoneType?.category ?? "",
    date: props.existingMilestoneType?.date ?? new Date(),
    user: props.existingMilestoneType?.user ?? formattedUser,
})

const toggleCategoryInput = () => {
    isAddingNewCategory.value = !isAddingNewCategory.value
    if(props.existingMilestoneType){
        milestoneType.value.category = props.existingMilestoneType.category
    } else {
        milestoneType.value.category = ""
    }
}

const handleIconSelected = (icon: string) => {
    milestoneType.value.icon = icon
}

const handleFormSubmit = () => {
    if(!milestoneType.value.title || !milestoneType.value.icon || !milestoneType.value.category){
        alert("Lütfen tüm alanları doldurunuz.")
        return
    }
    if (props.existingMilestoneType) {
        emits('milestoneTypeUpdated', milestoneType.value)
    } else {
        const { id, ...milestoneTypeWithoutId } = milestoneType.value
        console.log(id)
        emits('milestoneTypeAdded', milestoneTypeWithoutId)
    }
}

</script>

<template>
    <form @submit.prevent="handleFormSubmit" class="ac-main-form !border-none">
        <div class="ac-form-control">
            <label for="title">Temas Türü</label>
            <input type="text" id="title" class="" v-model="milestoneType.title">
        </div>
        <div class="ac-form-control">   
            <label for="icon">Temas Türü İkonu</label>
            <ac-icon-picker height="300px" @icon-selected="handleIconSelected" />
        </div>
        <div class="ac-form-control mt-16">
            <label for="category">Temas Türü Kategorisi</label>
            <div class="flex items-stretch justify-between">
        
                <input v-if="isAddingNewCategory" type="text" id="category" class="w-[93%]" v-model="milestoneType.category">
                <select v-else id="category" class="w-[93%] py-4" v-model="milestoneType.category">
                    <option value="" :selected="milestoneType.category === ''">Lütfen bir kategori seçin veya yeni bir kategori oluşturun.</option>
                    <option v-for="category in existingMilestoneCategories" :key="category" :value="category">{{ category }}</option>
                </select>
                <button type="button" class="ac-icon-button border w-[5%]" @click="toggleCategoryInput">
                    {{ isAddingNewCategory ? "x" : "+" }}
                </button>
            </div>
        </div>
        <div class="ac-button-row gap-2 flex items-center justify-center mt-8">
            <button type="submit" class="ac-primary-button w-2/6">
                <span v-if="!existingMilestoneType"> Temas Türü Oluştur </span>
                <span v-else> Temas Türü Güncelle </span>
            </button>
            <button type="button" class="ac-secondary-button w-2/6" @click="emits('cancelled')">İptal</button>
        </div>
    </form>
</template>